import type { CourseDetailAiFeedback } from './courseDetailAiFeedback';
import type { CourseDetailLocalizedSectionsItem } from './courseDetailLocalizedSectionsItem';
import type { CourseDetailSectionsItem } from './courseDetailSectionsItem';
import type { CourseDetailSummaryProperty } from './courseDetailSummaryProperty';
import type { CourseDetailTranslationsItem } from './courseDetailTranslationsItem';

export interface CourseDetail {
  /**
   * 사용자별 수강 등록에 대한 코스 종합 AI 피드백 (수강생이고 피드백 존재 시 반환)
   * @nullable
   */
  aiFeedback?: CourseDetailAiFeedback;
  /** 강의 상세 설명 */
  description: string;
  /** 언어별 커리큘럼 구성 정보 */
  localizedSections?: CourseDetailLocalizedSectionsItem[];
  sections: CourseDetailSectionsItem[];
  /** 강의 요약 정보 */
  summary: CourseDetailSummaryProperty;
  /** 언어별 강의 제목 및 설명 번역 */
  translations?: CourseDetailTranslationsItem[];
}
